const ZendeskEmbed = (() => {
	const instance = {
		element: undefined,
	}

	instance.hide = () => {
		window.zE('webWidget', 'hide')
	}

	instance.handleOnClose = () => {
		//window.zE('hideOnClose', false);
		//window.zE('webWidget:on', 'close', instance.hide);
	}

	instance.themeEmbed = () => {
		var style = getComputedStyle(document.body);
		const theme = style.getPropertyValue('--clr-season-accent');

		window.zESettings = {
			webWidget: {
				launcher: {
					chatLabel: {
						'*': 'Chat now',
					},
					mobile: {
						labelVisible: false,
					},
				},
				color: {
					theme: '#716F67',
				},
			},
		};
	}

	instance.show = (e) => {
		e.preventDefault();
		instance.themeEmbed();

		window.zE('webWidget', 'show');
		window.zE('webWidget', 'open');
	}

	instance.init = () => {
		const triggers = document.querySelectorAll('.chat-button');

		instance.themeEmbed();
		//instance.hide();
		instance.handleOnClose();

		window.zE('webWidget:on', 'open', () => {
			window.dataLayer.push({
				event: 'custom.chat.start',
				action: 'chat_start',
			});	
		})

		if(triggers && !!triggers.length) {
			triggers.forEach((trigger) => {
				trigger.addEventListener('click', instance.show);
			})
		}
	}

	instance.unload = () => {
		const triggers = document.querySelectorAll('.chat-button');

		//instance.hide();
		instance.handleOnClose();

		if(triggers && !!triggers.length) {
			triggers.forEach((trigger) => {
				trigger.removeEventListener('click', instance.show);
			})
		}
	}

	return instance;
})();

export default ZendeskEmbed;



// WEBPACK FOOTER //
// ./scripts/modules/zendesk.js